import { VARIANTS_ATTR_EMBARGO_EXTR_RELEASED_FALSE } from '@yme/common/constants';
import { getCategoryIds } from '@yme/pages/components/ProductsGrid/components/common';
export const buildRequestParamForAuthor = ({ categoryIds, productType, }) => {
    const categoryIdsList = categoryIds && getCategoryIds(categoryIds);
    if (!categoryIdsList) {
        return undefined;
    }
    return {
        query: `categories.id:subtree("${categoryIdsList}")|${VARIANTS_ATTR_EMBARGO_EXTR_RELEASED_FALSE}`,
        limit: 500,
        offset: 0,
        search: '',
        selectedFacets: '',
        sortOrder: '',
        productType,
    };
};
